module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-tab"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "base-info"
  }, _vm._l((_vm.baseInfo), function(Info) {
    return _c('li', {
      key: Info.attr,
      staticClass: "base-info-item"
    }, [_c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "placement": "top",
        "popper-class": "info-pop-class"
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_vm._v(_vm._s(Info.value4Show))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(Info.attrName) + " ： " + _vm._s(Info.value4Show))])])], 1)
  })), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "img-list"
  }, [(!_vm.imageInfo.length) ? _c('li', {
    staticClass: "empty"
  }, [_vm._v("暂无相关产品图片")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.imageInfo), function(img) {
    return _c('li', {
      key: img,
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": img
      },
      on: {
        "click": function($event) {
          _vm.imgBig(img)
        }
      }
    })])
  })], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.instructionInfo) ? _c('div', {
    staticClass: "ql-snow"
  }, [_c('div', {
    staticClass: "ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.instructionInfo)
    }
  })]) : _c('div', {
    staticClass: "empty"
  }, [_vm._v("暂无产品介绍")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "file-list"
  }, [_vm._l((_vm.fileList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "file"
    }, [_c('div', {
      staticClass: "file-item"
    }, [_c('div', {
      staticClass: "icon",
      class: _vm.fileIcoPath(item)
    }), _vm._v(" "), _c('div', {
      staticClass: "file-con"
    }, [_c('div', {
      staticClass: "file-name"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.filename))]), _vm._v(" "), _c('p', {
      staticClass: "size"
    }, [_vm._v(_vm._s(_vm._f("formatUnit")(item.size)))])]), _vm._v(" "), _c('div', {
      staticClass: "operate"
    }, [(_vm.isShowFile(item)) ? _c('a', {
      staticClass: "preview-btn",
      attrs: {
        "target": "_blank",
        "href": _vm.clickPreview(item)
      }
    }, [_vm._v("预览")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "download-btn",
      attrs: {
        "download": item.filename,
        "href": item.attachIndex
      }
    }, [_vm._v("下载")])])])])])
  }), _vm._v(" "), (!_vm.fileList.length) ? _c('li', {
    staticClass: "empty"
  }, [_vm._v("暂无相关文件")]) : _vm._e()], 2), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "other-infos"
  }, [_c('li', {
    staticClass: "other-item"
  }, [_c('span', [_vm._v("创建人：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.creator || '--'))])]), _vm._v(" "), _c('li', {
    staticClass: "other-item"
  }, [_c('span', [_vm._v("创建时间：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.addTime || '--'))])]), _vm._v(" "), _c('li', {
    staticClass: "other-item"
  }, [_c('span', [_vm._v("最后更新人：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.updater || '--'))])]), _vm._v(" "), _c('li', {
    staticClass: "other-item"
  }, [_c('span', [_vm._v("最后更新时间：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.updateTime || '--'))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "theme"
  }, [_c('i'), _c('span', [_vm._v("基本信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "theme"
  }, [_c('i'), _c('span', [_vm._v("产品图片")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "theme"
  }, [_c('i'), _c('span', [_vm._v("产品介绍")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "theme"
  }, [_c('i'), _c('span', [_vm._v("产品文件")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "theme"
  }, [_c('i'), _c('span', [_vm._v("其它信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-406f8392","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/product/product-tab.vue
// module id = 1254
// module chunks = 82